export const holidays = [
  '2025-01-01', '2025-03-03', '2025-03-04', '2025-03-24',
  '2025-04-02', '2025-04-17', '2025-04-18', '2025-05-01',
  '2025-05-02', '2025-06-16', '2025-06-20', '2025-07-09',
  '2025-08-15', '2025-11-21', '2025-11-24', '2025-12-08',
  '2025-12-24', '2025-12-25', '2025-12-31', '2026-01-01'
]
